import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  Input,
  Box,
  Alert,
  CircularProgress,
  Divider,
} from '@mui/material';
import { CloudUpload } from '@mui/icons-material';

const AddVideo = () => {
  const [video, setVideo] = useState(null);
  const [adminDetails, setAdminDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAdminDetails = async () => {
      try {
        const response = await fetch("https://backend.placemyfilms.com/admin/getAdmin");
        const data = await response.json();
        if (data && data.length > 0) {
          setAdminDetails(data[0]);
        }
      } catch (error) {
        console.error("Error fetching admin details:", error);
      }
    };
    fetchAdminDetails();
  }, []);

  const handleVideoChange = (e) => {
    const selectedVideo = e.target.files[0];
    setVideo(selectedVideo);
    setError('');
  };

  const handleVideoUpload = async () => {
    setError('');

    if (!video) {
      setError('Select a video');
      return;
    }

    if (!adminDetails) {
      setError('Admin details unavailable');
      return;
    }

    const formData = new FormData();
    formData.append('admin_id', adminDetails.id);
    formData.append('video', video);

    setLoading(true);

    try {
      const response = await fetch('https://backend.placemyfilms.com/videosUpload/admin/upload', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message);
      }

      setVideo(null);
      alert(`Video uploaded successfully! ID: ${data.result.id}`);
    } catch (error) {
      setError(`Upload error: ${error.message}`);
      console.error('Upload error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 500, margin: 'auto', mt: 6 }}>
      <Card
        sx={{
          boxShadow: 4,
          borderRadius: 3,
          background: 'linear-gradient(135deg, #f3f4f6, #e5e7eb)',
        }}
      >
        <CardHeader
          title={
            <Typography
              variant="h5"
              align="center"
              sx={{ fontWeight: 'bold', color: '#374151' }}
            >
              Admin Video Upload
            </Typography>
          }
        />
        <Divider />
        <CardContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Input
              type="file"
              inputProps={{ accept: 'video/*' }}
              onChange={handleVideoChange}
              disabled={loading}
              fullWidth
              sx={{
                background: '#ffffff',
                borderRadius: 2,
                p: 1,
                boxShadow: 1,
              }}
            />

            {video && (
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ fontStyle: 'italic' }}
              >
                Selected: {video.name}
              </Typography>
            )}

            <Button
              variant="contained"
              onClick={handleVideoUpload}
              disabled={!video || loading || !adminDetails}
              startIcon={!loading && <CloudUpload />}
              sx={{
                background: 'linear-gradient(135deg, #4ade80, #16a34a)',
                color: '#ffffff',
                borderRadius: 3,
                px: 4,
                py: 1,
                fontWeight: 'bold',
                textTransform: 'none',
                '&:hover': {
                  background: 'linear-gradient(135deg, #16a34a, #4ade80)',
                },
              }}
            >
              {loading ? <CircularProgress size={24} sx={{ color: '#ffffff' }} /> : 'Upload Video'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AddVideo;
